export default "__VITE_ASSET__PXItpABO__"